import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";

const selfEvalutionServiceApi = createApi({
    reducerPath: 'selfEvalutionServiceApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getSelfEvalutionIdByAppId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/SelfEvaluation/GetSelfEvalutionIdByAppId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getRequirementListForSectionABySGBPApplicationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/SelfEvaluation/GetRequirementListForSectionABySGBPApplicationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getRequirementListForSectionBBySGBPApplicationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/SelfEvaluation/GetRequirementListForSectionBBySGBPApplicationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getRequirementListForSectionCBySGBPApplicationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/SelfEvaluation/GetRequirementListForSectionCBySGBPApplicationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getRequirementAdditionalInputFieldForSectionABySGBPApplicationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/SelfEvaluation/GetRequirementAdditionalInputFieldForSectionABySGBPApplicationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        uploadPdfForSelfEvalution: builder.mutation({
            query: (details) => {
                return {
                    url: `/SelfEvaluation/UploadPdfForSelfEvalution`,
                    method: 'POST',
                    body: details
                };
            },
        }),
        downloadAllTypesDocForSelfEvalution: builder.mutation({
            query: (details) => {
                return {
                    url: `/SelfEvaluation/DownloadAllTypesDocForSelfEvalution`,
                    method: 'POST',
                    body: transformRequest(details),
                    responseHandler: (response) => response.blob(),
                };
            },
        }),
        deleteSelfEvalutionUploadedFileById: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/SelfEvaluation/DeleteSelfEvalutionUploadedFileById`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getRequirementAdditionalInputFieldForSectionBBySGBPApplicationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/SelfEvaluation/GetRequirementAdditionalInputFieldForSectionBBySGBPApplicationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getRequirementAdditionalInputFieldForSectionCBySGBPApplicationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/SelfEvaluation/GetRequirementAdditionalInputFieldForSectionCBySGBPApplicationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCriteriaRatingTickBySGBPProductInformationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/SelfEvaluation/GetCriteriaRatingTickBySGBPProductInformationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    }),
})

export const {
    useLazyGetSelfEvalutionIdByAppIdQuery,
    useLazyGetRequirementListForSectionABySGBPApplicationIdQuery,
    useLazyGetRequirementListForSectionBBySGBPApplicationIdQuery,
    useLazyGetRequirementListForSectionCBySGBPApplicationIdQuery,
    useLazyGetRequirementAdditionalInputFieldForSectionABySGBPApplicationIdQuery,
    useUploadPdfForSelfEvalutionMutation,
    useDownloadAllTypesDocForSelfEvalutionMutation,
    useDeleteSelfEvalutionUploadedFileByIdMutation,
    useLazyGetRequirementAdditionalInputFieldForSectionBBySGBPApplicationIdQuery,
    useLazyGetRequirementAdditionalInputFieldForSectionCBySGBPApplicationIdQuery,
    useLazyGetCriteriaRatingTickBySGBPProductInformationIdQuery
} = selfEvalutionServiceApi;

export default selfEvalutionServiceApi;